module.exports = __webpack_public_path__ + "img/moishop_portfolio_1_2x.aea954a4.png";